<template>
  <div class="page-container">
    <div class="page-title-container d-flex justify-content-between align-items-center">
      <h1 class="page-title mb-0">Provincias de {{ titleCase(dept) }}</h1>
      <b-button variant="none" class="button button-light" :to="{ name: 'ubigeo-departamentos' }">
        Volver
      </b-button>
    </div>

    <div class="table-container">
      <ubigeo-table-header @reload="loadData()" />

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th class="pl-3">Provincia</th>
              <th>Distritos activos</th>
              <th class="pr-md-4">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in rows" :key="p.provincia">
              <td class="pl-3 font-weight-bold">{{ titleCase(p.provincia) }}</td>
              <td class="text-center">
                <span :class="{ 'text-success font-weight-bold': p.activos > 0 }">{{ p.activos }}</span>
                <span class="text-muted"> / {{ p.total }}</span>
              </td>
              <td class="text-center pr-md-3">
                <button class="button button-light mr-2" @click="goDistritos(p.provincia)">
                  Ver distritos <i class="ri-arrow-right-line"></i>
                </button>
                <button class="button button-primary" @click="openActivateAll(p.provincia)">
                  <i class="ri-checkbox-multiple-line mr-1"></i> Activar todos
                </button>
              </td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="3" class="text-center text-muted py-4">Sin provincias.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <CityAssignModal v-model="modal.show" :title="modal.title" @confirm="onCityConfirm" />
  </div>
</template>

<script>
import { Alert } from 'wize-admin'
import { UbigeoService } from '@/core/services'
import CityAssignModal from '../Components/CityAssignModal.vue'
import UbigeoTableHeader from '../Components/UbigeoTableHeader.vue'

export default {
  name: 'ProvinceList',
  components: { CityAssignModal, UbigeoTableHeader },
  data() {
    return {
      rows: [],
      modal: { show: false, title: '', provincia: null }
    }
  },
  computed: {
    dept() { return this.$route.params.dept }
  },
  methods: {
    titleCase(s) {
      if (!s) return ''
      return String(s).toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    },
    goDistritos(prov) {
      this.$router.push({ name: 'ubigeo-distritos', params: { dept: this.dept, prov } })
    },
    openActivateAll(prov) {
      this.modal = { show: true, title: `Activar todos los distritos de ${this.titleCase(prov)}`, provincia: prov }
    },
    async onCityConfirm(cityId) {
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await UbigeoService.activateAll(this.modal.provincia, {
          city_id: cityId,
          departamento: this.dept
        })
        Alert.success(res.payload || 'Distritos activados')
        await this.loadData()
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'No se pudieron activar los distritos')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await UbigeoService.provincias(this.dept)
        this.rows = res.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al obtener provincias')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    }
  },
  async mounted() {
    await this.loadData()
  }
}
</script>
